export default {
      id: "i-tw-usage",
      viewBox: "0 5 23 12",
      url: __webpack_public_path__ + "img/sprite.svg#i-tw",
      toString: function () {
        return this.url;
      }
    }